<template>
  <div class="access-info x-margin x-border-50">
    <my-head-title
      :title="$t('HT.accessInfo.title')"
      :showEdit="$hasModule(16)"
      @edit="showEdit(formData)"
    ></my-head-title>
    <div class="ul-item x-padding-info">
      <my-info-item :title="$t('HT.accessInfo.name')" :info="formData.name"></my-info-item>
      <my-info-item :title="$t('HT.createdTime')" :info="formData.created_date"></my-info-item>
      <my-info-item :title="$t('HT.addAccess.type')" :optionText="false">
        <span>{{ $opt.switchStr(formData.type, $opt.accessType) }}</span>
      </my-info-item>
      <my-info-item
        :title="$t('HT.apiStepOne.remark')"
        :line="2"
        start
        :info="formData.remark"
      ></my-info-item>
    </div>
    <div class="tab">
      <el-tabs>
        <el-tab-pane :label="$t('HT.accessInfo.label1')">
          <ux-searchOption
            :layout="layout1"
            :data="filter"
            @input="seachApi"
            @search="seachApi"
            @change="changeApi"
            @showAdd="showBindApi"
          ></ux-searchOption>
          <ux-table
            ref="table"
            :showPage="true"
            :hide-on-single-page="true"
            :data="tableApiList.list"
            :total="tableApiList.totalSize"
            :columns="columns1"
            :curre-pagent.sync="filter.page"
            @changePage="changePage1"
            @changeSize="changeSize1"
            :emptyText="$t('HT.nodata')"
            layout="total, sizes, prev, pager, next"
          ></ux-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('HT.accessInfo.label2')">
          <ux-searchOption :layout="layout2" @showBindApp="showBindApp"></ux-searchOption>
          <ux-table
            ref="table"
            :showPage="true"
            :hide-on-single-page="true"
            :data="tableIpList.list"
            :total="tableIpList.totalSize"
            :columns="columns2"
            :size.sync="filter.size"
            :page.sync="filter.page"
            @changePage="changePage2"
            @changeSize="changeSize2"
            :emptyText="$t('HT.nodata')"
            layout="total, sizes, prev, pager, next"
          ></ux-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import addAccess from './template/addAccess';
import bindAccessIp from './template/bindAccessIp';
import bindApi from './template/bindApi';
import bindFlowApi from './template/bindFlowApi';
export default {
  components: {
    bindAccessIp,
    bindFlowApi,
    addAccess,
    bindApi
  },
  props: {
    model: {
      // 需要绑定的数据
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  updated() {
    this.$nextTick(() => {
      // document.querySelector('.ux-pagination.is-background')?.classList.remove('is-background');
    });
  },
  data() {
    return {
      id: this.$route.query.id, // id
      formData: {}, /// 详情数据
      tableIpList: {
        // 表数据
        totalSize: 0,
        list: []
      },
      tableApiList: {
        //已绑定Api列表表格数据
        totalSize: 0,
        list: []
      },
      groupList: [], // 分组列表
      filter: {
        // 查询参数
        name: '',
        env: '',
        page: 1,
        size: 10
      },
      layout1: [
        // 搜索项配置
        {
          type: 'select',
          options: this.$opt.env,
          key: 'env',
          placeholder: this.$t('HT.accessInfo.env.placeholder'),
          event: 'change',
          width: '170px'
        },
        {
          type: 'input',
          key: 'name',
          placeholder: this.$t('HT.rules.addApi.name')
        },
        {
          type: 'button',
          text: this.$t('HT.router.addApi'),
          hidden: !this.$hasModule(16),
          right: true,
          event: 'showAdd'
        }
      ],
      layout2: [
        // 搜索项配置
        {
          type: 'button',
          text: this.$t('HT.accessInfo.addIp'),
          hidden: !this.$hasModule(16),
          left: true,
          event: 'showBindApp'
        }
      ],
      columns1: [
        // 表格项
        {
          label: this.$t('HT.apiStepOne.name'),
          tooltip: true,
          prop: 'name'
        },
        {
          label: this.$t('HT.addAccessApi.evn'),
          prop: 'env',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return this.$opt.switchStr(cellValue, this.$opt.env);
          }
        },
        {
          label: this.$t('HT.router.api.groupList'),
          prop: 'group_name',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(16),
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.delete')],
                colors: ['#0087ff'],
                event: ['unbund']
              },
              on: {
                unbund: () => {
                  const title = this.$t('HT.accessInfo.delApi');
                  const content = this.$t('HT.accessInfo.delApi.placeholder');
                  this.$uxModal.show({
                    title,
                    content,
                    confirm: () => {
                      let postData = {
                        id: this.id,
                        boundId: params.id
                      };
                      this.unbindApi(postData);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      columns2: [
        {
          // 表格项
          label: 'IP',
          prop: 'addr',
          tooltip: true
        },
        {
          label: 'AppID',
          prop: 'app_id',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(16),
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.edit2'), this.$t('HT.delete')],
                colors: ['#0087ff'],
                event: ['update', 'unbund']
              },
              on: {
                update: () => {
                  this.showUpdate(params);
                },
                unbund: () => {
                  const title = this.$t('HT.accessInfo.delIp');
                  const content = this.$t('HT.accessInfo.delIp.placeholder');

                  this.$uxModal.show({
                    title,
                    content,
                    confirm: () => {
                      let postData = {
                        id: this.id,
                        boundId: params.id
                      };
                      this.unbindIp(postData);
                    }
                  });
                }
              }
            });
          }
        }
      ]
    };
  },
  created() {
    this.getInfo(this.id);
    this.getApiList(this.id, this.filter);
    this.getIpList(this.id);
  },

  mounted() {
    this.getGroupList();
  },

  methods: {
    /**
     * 详情数据
     * @param {Number} id id
     */
    getInfo(id) {
      this.$api.access.getInfo(id).then((res) => {
        if (res.code == 10000) {
          this.formData = res.data;
        }
      });
    },

    /**
     * 获取已绑定API列表
     * @param {Number} id 唯一标识
     */
    getApiList(id, value) {
      this.$uxLoading.show();
      this.$api.access.getApiList(id, value).then((res) => {
        if (res.code == 10000) {
          this.tableApiList = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 获取IP列表
     * @param {Number} id 唯一标识
     */
    getIpList(id, value) {
      this.$uxLoading.show();
      this.$api.access.getIpList(id, value).then((res) => {
        if (res.code == 10000) {
          this.tableIpList = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 绑定API弹窗
     */
    showBindApi() {
      const title = this.$t('HT.accessInfo.bindApi');

      this.$uxModal.show({
        title,
        hideBtn: true,
        content: (h) => {
          return h(bindFlowApi, {
            props: {
              data: this.groupList
            },
            on: {
              confirm: (data) => {
                this.$api.access.bindApis(this.id, data).then((res) => {
                  if (res.code == 10000) {
                    this.$uxModal.hide();
                    this.$uxMessage.success(this.$t('HT.addApi.bindSuccess'));
                    this.getApiList(this.id, this.filter1);
                  }
                });
              }
            }
          });
        }
      });
    },

    /**
     * 获取分组列表
     */
    getGroupList() {
      this.$api.group.getListData().then((res) => {
        if (res.code == 10000) {
          this.groupList = res.data;
        }
      });
    },

    /**
     * @description: 移除Api
     * @param {Object}  id
     */
    unbindApi(postData) {
      this.$api.access.unbindApi(postData).then((res) => {
        if (res.code == 10000) {
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          if (this.tableApiList.list.length === 1) {
            this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
          }
          this.getApiList(this.id, this.filter);
          this.$uxModal.hide();
        }
      });
    },
    /**
     * @description: 移除Ip
     * @param {Object} id
     */
    unbindIp(postData) {
      this.$api.access.unbindIp(postData).then((res) => {
        if (res.code == 10000) {
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          this.$uxModal.hide();
          if (this.tableApiList.list.length === 1) {
            this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
          }
          this.getIpList(this.id, this.filter);
        }
      });
    },

    /**
     * @description: api筛选
     */
    changeApi() {
      this.getApiList(this.id, this.filter);
    },
    /**
     * @description: 查询
     * @param {type}
     */
    seachApi() {
      this.getApiList(this.id, this.filter);
    },

    /**
     * 编辑
     * @param {Object} params 单行表格数据
     */
    showEdit(params) {
      const title = this.$t('HT.access.edit');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addAccess, {
            props: { data: params }
          });
        },
        confirm: (data) => {
          this.$uxLoading.show();
          this.$api.access.putList(data).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
              this.formData = data;
            }
          });
        }
      });
    },

    bindApi(params) {
      this.$api.api.flow(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.bindSuccess'));
          this.getApiList(this.id);
        }
      });
    },

    /**
     * 修改Ip列表弹窗
     * @param {Object} params 查询对象
     */
    showUpdate(params) {
      const title = this.$t('HT.accessInfo.editIp');

      this.$uxModal.show({
        title,
        content: (h) => {
          return h(bindAccessIp, {
            props: {
              data: params
            }
          });
        },
        confirm: (val) => {
          this.ipBind(val, this.id);
        }
      });
    },

    /**
     * 添加IP
     * @param {Object} params 对象
     */
    bind(params) {
      this.$api.access
        .addIpList(params.id, { addr: params.addr, app_id: params.app_id - 0 })
        .then((res) => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
            this.getIpList(this.id, this.filter);
          }
        });
    },
    /**
     * 修改IP
     * @param {Object} params 对象
     */
    ipBind(params, id) {
      this.$api.access
        .changeBind(id, params.id, { addr: params.addr, app_id: params.app_id })
        .then((res) => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.editSuccess2'));
            this.getIpList(this.id, this.filter);
          }
        });
    },
    /**
     * 解绑应用弹窗
     * @param {Object} params 查询对象
     */
    showUnbind(params) {
      const title = this.$t('HT.unbind.title');
      this.$uxModal.show({
        title,
        confirm: () => {
          this.unbind(params);
        }
      });
    },

    /**
     * 解绑
     * @param {Object} params 对象
     */
    unbind(params) {
      this.$uxLoading.show();
      this.$api.flow.unbind(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.unbindSuccess'));
          this.getInfoAppList(this.id);
        }
      });
    },

    showBindApp() {
      const title = this.$t('HT.accessInfo.addIpAddr');

      this.$uxModal.show({
        title,
        content: (h) => {
          return h(bindAccessIp, {
            props: { data: { id: this.id } }
          });
        },
        confirm: (data) => {
          this.bind(data);
        }
      });
    },
    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize1(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage1(page) {
      this.filter.page = page;
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize2(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage2(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>

<style lang="scss" scoped>
.access-info {
  box-sizing: border-box;

  .tab {
    padding: 0 20px 20px 20px;
  }

  .x-option-selection {
    height: auto;
    min-height: auto;
    margin-bottom: 20px;
  }

  .ul-item {
    display: flex;
    flex-wrap: wrap;

    .info-item {
      width: 100%;
    }
  }
}
</style>
